import { Schema, get } from '../../../json-transform';
import { baseGeneralEvent } from './baseGeneralEvent';

export const generalWsToEvent = (client) => new Schema({
  ...baseGeneralEvent(client),
  create_time: get('event-create-time'),
  end_time: get('event-end-time'),
  event_id: get('event.event_id'),
});
